import * as React from 'react'

import { SVGResponsive } from './common'

function Info({ color }: { color?: string }) {
  return (
    <SVGResponsive height={24} width={24}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
        stroke={color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 16V12"
        stroke={color || 'currentColor'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="8" r="0.5" fill="white" stroke="currentColor" />
    </SVGResponsive>
  )
}

export default React.memo(Info)
